import React from "react";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { FORM_URL_JAPAN, JAPAN_COURSES } from "../../data/courseDataJapan";

import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";

const JapanDemoForm = ({ initialLanguage = "", initialLevel = "" }) => {
  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [language, setLanguage] = React.useState(initialLanguage);
  const [level, setLevel] = React.useState(initialLevel);
  const [timing, setTiming] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [submitted, setSubmitted] = React.useState(false);

  React.useEffect(() => {
    if (initialLanguage) setLanguage(initialLanguage);
  }, [initialLanguage]);

  React.useEffect(() => {
    if (initialLevel) setLevel(initialLevel);
  }, [initialLevel]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name) return NotificationManager.error("お名前を入力してください");
    if (!email) return NotificationManager.error("メールアドレスを入力してください");
    if (!phone || !isValidPhoneNumber(phone)) {
      return NotificationManager.error("有効な電話番号を入力してください");
    }
    if (!language) return NotificationManager.error("コースを選択してください");
    if (!level) return NotificationManager.error("レベルを選択してください");
    if (!timing) return NotificationManager.error("希望の時間帯を選択してください");

    setLoading(true);

    const interest = JAPAN_COURSES[language]?.interest || language;
    const message = [
      "Demo Class Booking Request (Japan Market)",
      `Level: ${level}`,
      `Preferred Timing: ${timing}`,
      "Source: Japan Landing Page",
    ].join(" | ");

    try {
      const formData = new FormData();
      formData.append("entry.1102309209", name);
      formData.append("emailAddress", email);
      formData.append("entry.774180726", phone);
      formData.append("entry.1793295208", interest);
      formData.append("entry.371784238", message);

      await fetch(FORM_URL_JAPAN, {
        method: "POST",
        mode: "no-cors",
        body: formData,
      });

      NotificationManager.success("お申し込みが完了しました!");

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "lead_form_submit",
        course_interest: interest,
        page_path: window.location.pathname,
        form_type: "demo_booking_japan_landing",
      });

      setSubmitted(true);
    } catch (error) {
      NotificationManager.error("エラーが発生しました。もう一度お試しください。");
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="contact__card jl-thank-you">
        <div className="jl-thank-you__icon">✓</div>
        <h5>お申し込みありがとうございます!</h5>
        <p>
          担当者より24時間以内にご連絡し、無料体験レッスンの日程を確定いたします。
        </p>
        <a href="tel:+919990484089" className="btn btn-primary">
          お電話でのお問い合わせ: +91 99904 84089
        </a>
      </div>
    );
  }

  return (
    <div className="contact__card">
      <form onSubmit={handleSubmit} className="contact__card--form">
        <h5>無料体験レッスンを予約する</h5>
        <p className="jl-form-subtext">定員に限りがあります。お支払いは不要です。</p>

        <div className="contact__card--form-control">
          <input
            className="form-control"
            type="text"
            placeholder="お名前"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>

        <div className="contact__card--form-control">
          <PhoneInput
            className="form-control"
            international
            defaultCountry="JP"
            value={phone}
            onChange={(value) => {
              if (!value || value.length <= 15) {
                setPhone(value);
              }
            }}
            placeholder="電話番号を入力"
          />
        </div>

        <div className="contact__card--form-control">
          <input
            className="form-control"
            type="email"
            placeholder="メールアドレス"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="contact__card--form-control">
          <select
            className="form-control"
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
            required
          >
            <option value="">コースを選択</option>
            <option value="japanese">日本語コース</option>
            <option value="english">英会話コース</option>
          </select>
        </div>

        <div className="contact__card--form-control">
          <select
            className="form-control"
            value={level}
            onChange={(e) => setLevel(e.target.value)}
            required
          >
            <option value="">レベルを選択</option>
            <option value="初級">初級</option>
            <option value="中級">中級</option>
            <option value="上級">上級</option>
          </select>
        </div>

        <div className="contact__card--form-control">
          <select
            className="form-control"
            value={timing}
            onChange={(e) => setTiming(e.target.value)}
            required
          >
            <option value="">希望の時間帯</option>
            <option value="午前">午前</option>
            <option value="午後">午後</option>
            <option value="夜">夜</option>
          </select>
        </div>

        <button className="btn btn-primary" type="submit" disabled={loading}>
          {loading ? "送信中..." : "無料体験を予約する →"}
        </button>
      </form>

      <NotificationContainer />
    </div>
  );
};

export default JapanDemoForm;
